import { Edit } from '@mui/icons-material'
import { Button, Card, CardContent, CircularProgress, Grid, Typography, Divider } from '@mui/material'
import { LabelField } from 'components'
import { InboundTripDriverInformationDto, InboundTripDto } from 'dtos'
import { enqueueSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import DriverInformationAddEditDialog from './DriverInformationAddEditDialog'
import { useLoadingState } from 'hooks'
import * as controllers from 'controllers'

interface DriverInformationListCardProps {
  inboundTrip: InboundTripDto
}

export default function DriverInformationListCard({ inboundTrip }: DriverInformationListCardProps) {
  const [DriverInformationAddEditDialogOpen, setDriverInformationAddEditDialogOpen] = React.useState<boolean>(false)
  const [inboundTripDriverInformation, setInboundTripDriverInformation] = useState<InboundTripDriverInformationDto>(
    new InboundTripDriverInformationDto()
  )

  const [loadingState, setLoadingState] = useLoadingState({
    isGettingInboundTripDriverInformation: false,
    isUpdatingInboundTripDriverInformation: false
  })

  useEffect(() => {
    if (inboundTrip.inboundTripGuid) {
      setLoadingState('isGettingInboundTripDriverInformation', true)
      controllers
        .getInboundTripDriverInformation(inboundTrip.inboundTripGuid)
        .then(response => {
          setInboundTripDriverInformation(response.value)
          console.log(response.value)
        })
        .finally(() => {
          setLoadingState('isGettingInboundTripDriverInformation', false)
        })
    }
  }, [inboundTrip.inboundTripGuid])

  return (
    <>
      <DriverInformationAddEditDialog
        initialValues={inboundTripDriverInformation}
        inboundTrip={inboundTrip}
        isLoading={loadingState.isUpdatingInboundTripDriverInformation}
        onClose={() => {
          setDriverInformationAddEditDialogOpen(false)
        }}
        onSave={values => {
          setLoadingState('isUpdatingInboundTripDriverInformation', true)
          controllers
            .updateInboundTripDriverinformation(inboundTrip.inboundTripGuid!, values)
            .then(response => {
              setInboundTripDriverInformation(response.value)
              setDriverInformationAddEditDialogOpen(false)
              enqueueSnackbar('Driver Information Saved Successfully!', { variant: 'success' })
            })
            .finally(() => {
              setLoadingState('isUpdatingInboundTripDriverInformation', false)
            })
        }}
        open={DriverInformationAddEditDialogOpen}
      />

      <Card>
        <CardContent>
          <Grid container spacing={1} alignItems='flex-start'>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={12} sm={6}>
                <Typography fontWeight='bold' variant='h5'>
                  Driver Information
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto'>
                <Button
                  endIcon={<Edit />}
                  onClick={() => {
                    setDriverInformationAddEditDialogOpen(true)
                  }}
                  variant='text'
                  disabled={inboundTrip.isLocked}
                >
                  EDIT
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            {loadingState.isGettingInboundTripDriverInformation && (
              <Grid item container alignItems='center' justifyContent='center' sx={{ mt: 1 }}>
                <Grid item>
                  <CircularProgress color='primary' size={50} />
                </Grid>
              </Grid>
            )}

            {!loadingState.isGettingInboundTripDriverInformation && (
              <>
                <Grid item xs={12}>
                  <LabelField
                    label='Driver'
                    value={
                      inboundTripDriverInformation.driverPerson
                        ? `${inboundTripDriverInformation.driverPerson.firstName} ${inboundTripDriverInformation.driverPerson.lastName}`
                        : ''
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <LabelField label='Vehicle Plate' value={inboundTripDriverInformation.driverVehiclePlate} />
                </Grid>

                <Grid item xs={12}>
                  <LabelField label='Vehicle State/Province' value={inboundTripDriverInformation.driverVehicleState} />
                </Grid>

                <Grid item xs={12}>
                  <LabelField label='Vehicle Country' value={inboundTripDriverInformation.driverVehicleCountry} />
                </Grid>

                <Grid item xs={12}>
                  <LabelField label='Trailer Plate' value={inboundTripDriverInformation.driverTrailerPlate} />
                </Grid>

                <Grid item xs={12}>
                  <LabelField label='Trailer State/Province' value={inboundTripDriverInformation.driverTrailerState} />
                </Grid>

                <Grid item xs={12}>
                  <LabelField label='Trailer Country' value={inboundTripDriverInformation.driverTrailerCountry} />
                </Grid>

                <Grid item xs={12}>
                  <LabelField label='Crew Member' value={inboundTripDriverInformation.driverCrewMember} />
                </Grid>
              </>
            )}
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
